import { ensureModuleMessages, registerModuleCatalog } from '@/shared/i18n/i18n';
registerModuleCatalog('tenant-request', (locale) => import(`./locales/${locale}.po`), {
  eager: true,
});
export const loadTenantRequestMessages = () => ensureModuleMessages('tenant-request');
